import { execute_generator } from './index'

export const api_url = process.env.VUE_APP_API_TBN_URL
export const tbn_api_url = process.env.VUE_APP_API_TBN_URL

export const get_tbn_actuals = (tenant, filter, booking_search, base, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/actuals/web?tenant=' + tenant + '&filter=' + filter + '&booking_search=' + booking_search + '&base=' + base + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const reprocess_actuals = (tenant, filter, base, fromDate, toDate) => execute_generator(
    'PATCH', { service: api_url, resource: 'tbn/actuals/reprocess?tenant=' + tenant + '&filter=' + filter  + '&base=' + base + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_hos_by_client_report = (tenant, from, to, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/hoursByClient?tenant=' + tenant + '&fromDate=' + from + '&toDate=' + to + '&reprocess=' + reprocess}
).next()

export const get_tyler_route_options = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/tyler_routes/options?tenant=' + tenant}
).next()

export const process_tyler_routes = (tenant, location, inQA) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/tyler_routes/process?tenant=' + tenant + "&location=" + location +"&inQA=" + inQA}
).next()



export const get_hos_by_booking_report = (tenant, from, to, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/hoursByBooking?tenant=' + tenant + '&fromDate=' + from + '&toDate=' + to + '&reprocess=' + reprocess}
).next()

export const get_tbn_booking_history = (tenant, processed_time) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/booking/history?tenant=' + tenant + '&processed_time=' + processed_time}
).next()

export const tbn_get_simulated_actuals = (tenant, show_details) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/actuals/simulated?tenant=' + tenant + '&show_details=' + show_details}
).next()

export const tbn_get_vehicle_types = (tenant) => execute_generator(
'GET', { service: api_url, resource: 'tbn/vehicles/types?tenant=' + tenant}
).next()

export const get_compare_drivers_history = (tenant, from, to) => execute_generator(
'GET', { service: api_url, resource: 'tbn/comparedrivers/history?tenant=' + tenant + '&fromDate=' + from + '&toDate=' + to}
).next()

export const tbn_get_compare_drivers_results = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/comparedrivers?tenant=' + tenant}
).next()

export const tbn_get_compare_driver_profile_results = (tenant) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/comparedriverprofiles?tenant=' + tenant}
).next()

export const tbn_manage_drivers_list = (tenant) => execute_generator(
'GET', { service: api_url, resource: 'tbn/drivers/manage/list?tenant=' + tenant}
).next()

export const tbn_get_driver = (tenant, id) => execute_generator(
'GET', { service: api_url, resource: 'tbn/drivers/' + id + '?tenant=' + tenant}
).next()

export const tbn_update_driver = (tenant, body) => execute_generator(
'PUT', { service: api_url, resource: 'tbn/drivers?tenant=' + tenant}, body
).next()


export const tbn_save_driver_sync_mappings = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/driversync?tenant=' + tenant}, body
).next()

export const tbn_add_driver_to_tbn = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/driversync/addDriverToTBN?tenant=' + tenant}, body
).next()

export const get_tbn_vehicle_info = (tenant, selected_base, selected_tag) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicles?tenant=' + tenant + "&selected_base=" + selected_base + "&selected_tag=" + selected_tag}
).next()

export const get_tbn_trip_sheet = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/tripsheet?tenant=' + tenant + "&date=" + date}
).next()

export const tbn_get_smart_route_assignments = (tenant, vehicleTypes, fromDate, toDate, autoselect) => execute_generator(
'GET', { service: api_url, resource: 'tbn/smart_route_assignments?tenant=' + tenant + '&vehicleTypes=' + vehicleTypes + '&fromDate=' + fromDate + '&toDate=' + toDate + '&autoselect=' + autoselect}
).next()

export const tbn_update_smart_route_assignment = (tenant, body) => execute_generator(
'PATCH', { service: api_url, resource: 'tbn/smart_route_assignments?tenant=' + tenant}, body
).next()

export const tbn_send_smart_route_assignment_to_tbn = (tenant, body) => execute_generator(
'PATCH', { service: api_url, resource: 'tbn/smart_route_assignments/send_to_tbn?tenant=' + tenant}, body
).next()

export const get_dispatch_board = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/dispatch_board?tenant=' + tenant + "&date=" + date}
).next()

export const tbn_update_vehicle_status = (tenant, body) => execute_generator(
    'PATCH', { service: api_url, resource: 'tbn/vehicles?tenant=' + tenant}, body
).next()

export const get_tbn_vehicle_map = (tenant, vehicle_id, samsara_vehicle_id, booking_id) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/map?tenant=' + tenant + "&vehicleId=" + vehicle_id + "&samsaraVehicleId=" + samsara_vehicle_id + "&bookingId=" + booking_id}
).next()

export const get_tbn_vehicle_trip_history = (tenant, value, fromDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/trip/history?tenant=' + tenant + "&vehicle=" + value + "&fromDate=" + fromDate}
).next()

export const get_vehicle_track_fleet_tbn = (tenant, mode, value) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/track/fleet?tenant=' + tenant + "&mode=" + mode + "&value=" + value}
).next()

export const get_tbn_actuals_mileage_report = (tenant, date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/mileage?tenant=' + tenant + '&date=' + date + '&reprocess=' + reprocess}
).next()

export const get_tbn_actuals_billing_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/billing?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_actuals_start_events_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/startevents?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_actuals_driver_payroll_report = (tenant, date, reprocess, useBookingActuals) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/driverpayroll?tenant=' + tenant + '&date=' + date + '&reprocess=' + reprocess + '&useBookingActuals=' + useBookingActuals}
).next()

export const tbn_push_actuals_driver_multiday_to_payroll = (tenant, tag, driver, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/driver/multiday/push?tenant=' + tenant + '&tag=' + tag + '&driver=' + driver + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const get_tbn_intrastate_booking_report = (tenant, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/intrastate_bookings?tenant=' + tenant + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const get_tbn_smart_routing_report = (tenant, from_date, to_date, vehicleType, matchType, miles, min_minutes, max_minutes) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/smart_routing_report?tenant=' + tenant + '&fromDate=' + from_date + '&toDate=' + to_date + '&vehicleType=' + vehicleType + '&matchType=' + matchType + '&miles=' + miles + '&minMinutes=' + min_minutes + '&maxMinutes=' + max_minutes}
).next()

export const get_tbn_vehicle_map_future_data = (tenant, from_date, to_date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle_map_future_data?tenant=' + tenant + '&fromDate=' + from_date + '&toDate=' + to_date}
).next()

export const get_tbn_vehicle_map_future_charter_data = (tenant, booking_search) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle_map_future_charter_data?tenant=' + tenant + '&booking_search=' + booking_search}
).next()

export const get_tbn_actuals_driver_multiday_report = (tenant, tag, driver, from_date, to_date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/driver/multiday?tenant=' + tenant + '&tag=' + tag + '&driver=' + driver + '&fromDate=' + from_date + '&toDate=' + to_date + '&reprocess=' + reprocess}
).next()

export const get_tbn_actuals_payroll_summary_report = (tenant, driver, from_date, to_date, reprocess) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/payroll/summary?tenant=' + tenant + '&driver=' + driver  + '&fromDate=' + from_date + '&toDate=' + to_date + '&reprocess=' + reprocess}
).next()


export const get_tbn_vehicle_utilization = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/utilization?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_driver_utilization = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver/utilization?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_vehicle_calendar = (tenant, hours_offset, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/calendar?tenant=' + tenant + '&hours_offset=' + hours_offset + '&date=' + date}
).next()

export const get_tbn_drivers_dispatch_weekly = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver/dispatch/weekly?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_drivers_util_weekly = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/driver/util/weekly?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_vehicle_type_calendar = (tenant, type_mode, hours_offset, fromDate, toDate) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/vehicle/type/calendar?tenant=' + tenant + '&hours_offset=' + hours_offset + '&type_mode=' + type_mode + '&fromDate=' + fromDate + '&toDate=' + toDate}
).next()

export const get_tbn_actuals_perf_report = (tenant, date) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/performance?tenant=' + tenant + '&date=' + date}
).next()

export const get_tbn_multiday_otp_report = (tenant, base, fromDate, toDate, dayThreshold, startThreshold, finishThreshold, totalThreshold) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/reports/actuals/multiday/otp?tenant=' + tenant + '&base=' + base + '&fromDate=' + fromDate + '&toDate=' + toDate + '&dayThreshold=' + dayThreshold + '&startThreshold=' + startThreshold + '&finishThreshold=' + finishThreshold + '&totalThreshold=' + totalThreshold }
).next()

export const get_groupsender_user_list = (tenant, user_type, driverStartTime, driverEndTime) => execute_generator(
    'GET', { service: api_url, resource: 'tbn/groupsender/users?tenant=' + tenant + '&userType=' + user_type + '&driverStartTime=' + driverStartTime + '&driverEndTime=' + driverEndTime}
).next()

export const send_message_to_group = (tenant, body) => execute_generator(
    'POST', { service: api_url, resource: 'tbn/groupsender/send?tenant=' + tenant}, body
).next()




